import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { ReportFromToComponent } from '../report-from-to/report-from-to.component';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';


@Component({
  selector: 'app-report-medical',
  templateUrl: './report-medical.component.html',
  styleUrls: ['./report-medical.component.css']
})
export class ReportMedicalComponent implements OnInit {
  ReportURL00 =  'CocReports/PatVisitsDoctor';
  ReportURL0 =  'CocReports/PatintLis_Gendr_CancerType_Detailed';
  ReportURL0_0 = 'CocReports/PatintLis_Gendr_CancerType_Detailed_All';
  ReportURLSummary = 'CocReports/PatintLis_Gendr_CancerType_Month_Total';
  ReportURL1 =  'CocReports/PatintLis_CancerType_Detailed';
  ReportURLMortality = 'CocReports/PatientMortality';
  ReportURLPatientCancer_0 ='CocReports/PatintLis_Gendr_CancerType_All';
  ReportURLPatientGov_0 ='CocReports/PatByGov';
  ReportURLPatientNat_0 ='CocReports/PatByNationalty';
  ReportURLMortality_0 = 'CocReports/PatientMortality_All';
  ReportURLPatientList_0 = 'CocReports/PatintLis_ByDate_Detailed';
  ReportURL2 =  'CocReports/PatintLis_Gendr_CancerType_Month';
  ReportURL3 =  'CocReports/PatintLis_Gendr_Status_Detailed';
  ReportURL5 =  'CocReports/ExaminationDet';
  ReportURL10 =  'CocReports/FollowUpVisit';
  ReportURL11 =  'CocReports/PatByNationalty';
  PatientCode ='';
  fromDate='';
  toDate='';
  fromDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  toDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  screenTitle ='';

  constructor(public route: Router,
     private dialogref: MatDialog,
     private prepHDSelecteData:DoctorsModel,
     public storage: LocalStorageService,
     public doctorSelectedData: DoctorsModel) { }

  ngOnInit(): void {
  }
  ReportPatient0(){
    this.route.navigate(['report-vewier', this.ReportURL00]);
  }
  ReportPatient1(){
    this.route.navigate(['report-vewier', this.ReportURL0]);
  }
  ReportPatient2(){
    this.route.navigate(['report-vewier', this.ReportURL1]);
  }
  ReportPatient3(){
    this.route.navigate(['report-vewier', this.ReportURL2]);
  }
  ReportPatient4(){
    this.route.navigate(['report-vewier', this.ReportURL3]);
  }

  ReportPatient5(){
    this.route.navigate(['report-vewier', this.ReportURL5]);
  }

  openDialog_0(){
    this.screenTitle ='Patient number doctors care by service';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data: {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_Y-Butt_Y-Room_N-Can_N-Mor_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docWMMobile;
        this.toDate = result.docWmail;
        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDate);
        this.storage.store('stgParD2', this.toDate);
        this.storage.store('stgPar3', result.docCode);

        this.screenTitle ='Patient number doctors care by service';
        this.storage.store('stgTitel', this.screenTitle);
        this.route.navigate(['report-vewier', this.ReportURL00]);

      });
  }

  openDialog(){
    this.screenTitle ='Number of patients for every gender';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data: {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_Y-Mor_N'}

      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docWMMobile;
        this.toDate = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDate);
        this.storage.store('stgParD2', this.toDate);
        this.storage.store('stgPar3', result.docUser);


        this.screenTitle ='Number of patients for every gender';
        this.storage.store('stgTitel', this.screenTitle);
        if(result.docUser == '' || result.docUser == null){this.route.navigate(['report-vewier', this.ReportURL0_0])}
        if(result.docUser != '') {this.route.navigate(['report-vewier', this.ReportURL0])};

      });
  }
  openDialogSummary(){
    this.screenTitle ='Number of patients for every gender (summary)';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data: {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_N-Mor_N'}

      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docWMMobile;
        this.toDate = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDate);
        this.storage.store('stgParD2', this.toDate);
        this.storage.store('stgPar3', result.docUser);


        this.screenTitle ='Number of patients for every gender (summary)';
        this.storage.store('stgTitel', this.screenTitle);
       this.route.navigate(['report-vewier', this.ReportURLSummary]);

      });
  }
  openDialog1(){
    this.screenTitle ='Number of patients by cancer type (details)';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_Y-Mor_N'}

      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docWMMobile;
        this.toDate = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgPar1', this.fromDate);
        this.storage.store('stgPar2', this.toDate);
        this.storage.store('stgPar3', result.docUser);

        this.screenTitle ='Number of patients by cancer type (details)';

        this.storage.store('stgTitel', this.screenTitle);
        ///console.log(" this.storage : " + this.storage.retrieve('stgTitel') + " screenTitle : " +this.screenTitle )
        this.route.navigate(['report-vewier', this.ReportURL1]);

      });
  }
  openDialog_4(){
    this.screenTitle ='Clinic patient Status';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_N-Mor_N'}

      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {


        this.fromDate = result.docWMMobile;
        this.toDate = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgPar1', this.fromDate);
        this.storage.store('stgPar2', this.toDate);
        this.storage.store('stgPar3', result.docUser);

        this.screenTitle ='Clinic patient Status';

        this.storage.store('stgTitel', this.screenTitle);
        ///console.log(" this.storage : " + this.storage.retrieve('stgTitel') + " screenTitle : " +this.screenTitle )
        this.route.navigate(['report-vewier', this.ReportURL3]);

      });
  }
  MortalityDilaog(){
    this.screenTitle ='Mortality Report';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_Y-Mor_Y'}

      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docWMMobile;
        this.toDate = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgPar1', this.fromDate);
        this.storage.store('stgPar2', this.toDate);
        this.storage.store('stgPar3', result.docUser);
        this.storage.store('stgPar4', result.docMobile);



        this.screenTitle ='Mortality Report';

        this.storage.store('stgTitel', this.screenTitle);
        this.route.navigate(['report-vewier', this.ReportURLMortality]);



      });
  }
  PatienDateDilaog(){
    this.screenTitle ='Patient List From Date To Date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_N-Mor_N'}

      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docWMMobile;
        this.toDate = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgPar1', this.fromDate);
        this.storage.store('stgPar2', this.toDate);


        this.screenTitle ='Patient List From Date To Date';

        this.storage.store('stgTitel', this.screenTitle);
        this.route.navigate(['report-vewier', this.ReportURLPatientList_0])



      });
  }
  PatienCancerDilaog(){
    this.screenTitle ='Patient List From Date To Date By Cancer Type';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_Y-Mor_N'}

      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docWMMobile;
        this.toDate = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgPar1', this.fromDate);
        this.storage.store('stgPar2', this.toDate);
        this.storage.store('stgPar3', result.docUser);


        this.screenTitle ='Patient List From Date To Date By Cancer';

        this.storage.store('stgTitel', this.screenTitle);
        this.route.navigate(['report-vewier', this.ReportURLPatientCancer_0])



      });
  }
  PatienGovDilaog(){
    this.screenTitle ='Patient List From Date To Date By Governorate';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_N-Mor_N'}

      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docWMMobile;
        this.toDate = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgPar1', this.fromDate);
        this.storage.store('stgPar2', this.toDate);


        this.screenTitle ='Patient List From Date To Date By Governorate';

        this.storage.store('stgTitel', this.screenTitle);
        this.route.navigate(['report-vewier', this.ReportURLPatientGov_0])



      });
  }
  PatienNatDilaog(){
    this.screenTitle ='Patient List From Date To Date By Nationality';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_N-Mor_N'}

      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docWMMobile;
        this.toDate = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgPar1', this.fromDate);
        this.storage.store('stgPar2', this.toDate);


        this.screenTitle ='Patient List From Date To Date By Nationality';

        this.storage.store('stgTitel', this.screenTitle);
        this.route.navigate(['report-vewier', this.ReportURLPatientNat_0])



      });
  }
  openDialog_5(){
    this.screenTitle ='Patient Examiniation from Date To Date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_Y-Doc_N-Butt_N-Room_N-Can_N-Mor_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.patientFName ;
        this.toDate = result.birthDate;
        this.fromDateD = result.telHome;
        this.toDateD = result.patientFullName;
        this.PatientCode = result.patientCode;

          console.log("docAddress ", this.fromDateD + "   result.patientFullName :" + result.patientFullName  );

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.PatientCode);

        console.log("stgParD1 ",this.storage.retrieve('stgParD2'));

        this.route.navigate(['report-vewier', this.ReportURL5]);

      });
  }
  openDialog_6(){
    this.screenTitle ='Number of patients per year (Graph)';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_y-Date_N-Pat_N-Doc_N-Butt_Y-Room_N-Can_N-Mor_N'}

      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgPar1', this.fromDate);
        this.storage.store('stgPar2', this.toDate);
        this.screenTitle ='Number of Patient By Gendr and Cancer Type';

        this.storage.store('stgTitel', this.screenTitle);
        ///console.log(" this.storage : " + this.storage.retrieve('stgTitel') + " screenTitle : " +this.screenTitle )
        this.route.navigate(['report-vewier', this.ReportURL3]);

      });
  }
  openDialog_10(){
    this.screenTitle ='Patients Visits';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_N-Pat_Y-Doc_N-Butt_N-Room_N-Can_N-Mor_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.patientFName ;
        this.toDate = result.birthDate;
        this.fromDateD = result.telHome;
        this.toDateD = result.patientFullName;
        this.PatientCode = result.patientCode;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.PatientCode);



        this.route.navigate(['report-vewier', this.ReportURL10]);

      });
  }
  openDialog_11(){
    this.screenTitle ='Patients By Nationality';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_N-Mor_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docWMMobile;
        this.toDate = result.docWmail;
        this.fromDateD = result.telHome;
        this.toDateD = result.patientFullName;
        this.PatientCode = result.patientCode;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDate);
        this.storage.store('stgParD2', this.toDate);
        this.storage.store('stgParD3', this.PatientCode);



        this.route.navigate(['report-vewier', this.ReportURL11]);

      });
  }

}
